export default "__VITE_ASSET__NSvr$wCv__"